<template>
  <div class="SupplementFacts-Row" :class="rowClass">
    <div class="SupplementFacts-Col-Name" :class="[indentClass, { 'text-bold': boldName }]">
      <slot name="name">{{ name }}</slot>
    </div>
    <div class="SupplementFacts-Col-Amount">
      <slot name="amount">{{ amount }}</slot>
    </div>

    <template v-if="showDvColumn">
      <template v-if="isMultiColumn">
        <div
          v-for="(cat, idx) in ageCategories"
          :key="cat"
          class="SupplementFacts-Col-DV"
          :class="dvClass"
          :style="getColumnStyle(idx)"
          :data-test-id="`dv-value-${cat}`"
        >
          <slot name="dv" :category="cat"></slot>
        </div>
      </template>
      <div v-else class="SupplementFacts-Col-DV" :class="dvClass" data-test-id="dv-value-single">
        <slot name="dv"></slot>
      </div>
    </template>
  </div>
  <div v-if="$slots.extra" class="SupplementFacts-Row SupplementFacts-ExtraRow" :class="rowClass">
    <div class="SupplementFacts-Col-Name" :class="indentClass">
      <slot name="extra"></slot>
    </div>
  </div>
  <div v-if="showDivider && dividerClass" :class="dividerClass"></div>
</template>

<script setup>
  const props = defineProps({
    name: { type: String, default: "" },
    amount: { type: [String, Number], default: "" },
    rowClass: { type: String, default: "" },
    indentClass: { type: String, default: "" },
    boldName: { type: Boolean, default: false },
    isMultiColumn: { type: Boolean, default: false },
    ageCategories: { type: Array, default: () => [] },
    columnWidths: { type: Array, default: () => [] },
    dvClass: { type: [String, Object], default: "" },
    showDivider: { type: Boolean, default: false },
    dividerClass: { type: String, default: "SupplementFacts-Bar-Hairline" },
    showDvColumn: { type: Boolean, default: true },
  });

  const getColumnStyle = (idx) => {
    if (props.columnWidths[idx]) {
      return { width: props.columnWidths[idx] + "px" };
    }
    return {};
  };
</script>

<style lang="scss">
  @import "~label/css/labels/supplements/supplement_facts";
</style>
